import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

import {
  EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK,
  experimentsTrackEvent,
} from '../../../experiments/eventTracking'
import { useGetExperiment } from '../../../experiments/hooks'
import { EXPERIMENT_NAME_SEARCH_PAGE_REFINED_QUERY_SUGGESTIONS } from '../../../experiments/model/EXPERIMENT_NAME.ts'
import { useGlobalConfigContext } from '../../../global-config'
import { productSearchAlgoliaAccessorGetOffersData } from '../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetOffersData'
import { productSearchAlgoliaAccessorGetVariantsData } from '../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetVariantsData'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'
import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemLabels/ProductSearchResultItemGenericLabel'

export const ProductSearchResultItemProductLinkWithIcon: FC = () => {
  const { algoliaRecord, isMarketplace, query } =
    useProductSearchResultItemContext()
  const globalConfig = useGlobalConfigContext()
  const searchPageRefinedQuerySuggestionsExperiment = useGetExperiment(
    EXPERIMENT_NAME_SEARCH_PAGE_REFINED_QUERY_SUGGESTIONS,
  )
  const { productHasMultipleVariants } =
    productSearchAlgoliaAccessorGetVariantsData(algoliaRecord)
  const productSellerCount = algoliaRecord.seller_count

  const {
    hasNonBestOfferSellerPromotion,
    productUrl,
    shouldDisplayLinkToOfferPage,
  } = productSearchAlgoliaAccessorGetOffersData(
    algoliaRecord,
    isMarketplace,
    query,
  )

  return (
    <>
      {productHasMultipleVariants ? (
        <Button<'a'>
          className="z-10 text-dark-primary-max"
          endIcon={<IconArrowRight />}
          href={productUrl}
          onClick={() => {
            if (searchPageRefinedQuerySuggestionsExperiment.isEnabled) {
              experimentsTrackEvent(
                globalConfig,
                EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK,
              )
            }
          }}
          size="medium"
          variant="text"
        >
          <FormattedMessage id="product.variants.configure.link" />
        </Button>
      ) : null}

      {shouldDisplayLinkToOfferPage ? (
        <>
          {hasNonBestOfferSellerPromotion ? (
            <ProductSearchResultItemGenericLabel className="w-fit border-none bg-light-tertiary">
              <FormattedMessage id="seller.promotion.product.badge" />
            </ProductSearchResultItemGenericLabel>
          ) : null}
          <Button<'a'>
            className="z-10 text-dark-primary-max"
            endIcon={<IconArrowRight className="text-dark-brand" />}
            href={productUrl}
            onClick={() => {
              if (searchPageRefinedQuerySuggestionsExperiment.isEnabled) {
                experimentsTrackEvent(
                  globalConfig,
                  EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK,
                )
              }
            }}
            size="medium"
            variant="text"
          >
            <FormattedMessage
              id="product.seller.count"
              values={{ count: productSellerCount }}
            />
          </Button>
        </>
      ) : null}
    </>
  )
}
